var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./cardAlert.ts"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-5dbe3ee4\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./cardAlert.vue.html"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/home/cards/cardAlert/cardAlert.vue.html
// module id = KdA+
// module chunks = 2